define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrSysStatusDomain = void 0;
    class SrCrSysStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SrCrSysStatusDomain.Active, value: "Active" },
                    { key: SrCrSysStatusDomain.Archived, value: "Archived" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SrCrSysStatusDomain.Active] = 0;
                this.KeyIndex[SrCrSysStatusDomain.Archived] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Active"] = 0;
                this.ValueIndex["Archived"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SrCrSysStatusDomain = SrCrSysStatusDomain;
    Object.defineProperty(SrCrSysStatusDomain, "Active", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(SrCrSysStatusDomain, "Archived", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(SrCrSysStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
